import React from 'react'
export default function CaptionedIcon() {
    return (
        <svg  viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.62678 11.9966V14.0346C8.84682 14.4497 7.86558 14.6384 6.95982 14.6384C4.02868 14.6384 2.0033 12.613 2.0033 9.95864C2.0033 7.31684 4.02868 5.25372 6.95982 5.25372C7.87816 5.25372 8.77134 5.46758 9.4884 5.81982V7.8452C8.82166 7.39232 7.90332 7.05266 6.9724 7.05266C5.2112 7.05266 4.00352 8.2855 4.00352 9.93348C4.00352 11.5563 5.17346 12.8395 7.04788 12.8395C7.99138 12.8395 8.87198 12.5124 9.62678 11.9966Z" fill="black"/>
        <path d="M17.9379 11.9966V14.0346C17.158 14.4497 16.1767 14.6384 15.271 14.6384C12.3398 14.6384 10.3144 12.613 10.3144 9.95864C10.3144 7.31684 12.3398 5.25372 15.271 5.25372C16.1893 5.25372 17.0825 5.46758 17.7996 5.81982V7.8452C17.1328 7.39232 16.2145 7.05266 15.2835 7.05266C13.5223 7.05266 12.3147 8.2855 12.3147 9.93348C12.3147 11.5563 13.4846 12.8395 15.359 12.8395C16.3025 12.8395 17.1831 12.5124 17.9379 11.9966Z" fill="black"/>
        </svg>

    )
}


